import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { GeneralFaqState, SLICE_NAME } from './models';

const generalFaqSelector = (state: RootState): GeneralFaqState => state[SLICE_NAME];

export const selectGeneralFaqs = createSelector(generalFaqSelector, (state: GeneralFaqState) => state.faqs);

export const selectGeneralFaqsIsLoading = createSelector(
  generalFaqSelector,
  (state: GeneralFaqState) => state.isLoading,
);

export const selectGeneralFaqsError = createSelector(generalFaqSelector, (state: GeneralFaqState) => state.error);

export const selectGeneralFaqsPagination = createSelector(
  generalFaqSelector,
  (state: GeneralFaqState) => state.pagination,
);
